module.exports = __webpack_public_path__ + "static/img/brand-2.3eaa1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/brand-2.png
// module id = SzcQ
// module chunks = 0